import React, { useState } from "react";
import { ShieldCheck, Phone, Clock, Menu, X } from "lucide-react";
import logo from "../assets/images/logo.png";
import { Link } from "react-router-dom";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToFAQ = (e) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    const faqSection = document.getElementById('faq-section');
    if (faqSection) {
      faqSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="w-full sticky top-0 z-50 bg-white shadow-lg">
      {/* Top Bar */}
      <div className="bg-gradient-to-r from-blue-700 via-indigo-700 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-col sm:flex-row items-center justify-between py-2 gap-2">
            <div className="flex items-center flex-wrap justify-center gap-4 sm:gap-6 text-sm">
              <span className="flex items-center gap-2 hover:text-blue-200 transition-colors">
                <Clock size={14} />
                <span className="hidden sm:inline">Mon–Fri: 8AM–6PM</span>
                <span className="sm:hidden">8AM–6PM</span>
                <span className="hidden lg:inline"> | Sat–Sun: 9AM–6PM</span>
              </span>
              <span className="hidden md:inline bg-blue-500/20 px-2 py-0.5 rounded-full text-xs font-medium">
                Same Day Services
              </span>
              <span className="flex items-center gap-2 hover:text-blue-200 transition-colors">
                <ShieldCheck size={14} />
                24×7 Emergency
              </span>
            </div>

            <Link
              to="/contact"
              className="bg-gradient-to-r from-amber-400 to-yellow-400 hover:from-amber-500 hover:to-yellow-500 text-gray-900 font-bold px-5 py-2 rounded-full shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-95 transition-all duration-300 text-sm"
            >
              Get Free Quote
            </Link>
          </div>
        </div>
      </div>

      {/* Main Nav */}
      <div className="border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between py-4">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-3 cursor-pointer group">
              <img
                src={logo}
                alt="Knight Cleaning"
                className="h-14 w-14 rounded-full shadow-lg object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <div>
                <h1 className="text-2xl font-bold bg-gradient-to-r from-blue-700 to-indigo-800 bg-clip-text text-transparent">
                  Knight Cleaning
                </h1>
                <p className="text-xs text-gray-600 tracking-wider font-medium">
                  PREMIUM CLEANING SOLUTIONS
                </p>
              </div>
            </Link>

            {/* Desktop Menu */}
            <nav className="hidden lg:flex items-center gap-8">
              <Link
                to="/"
                className="font-semibold text-gray-800 hover:text-blue-600 transition-colors relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-blue-600 after:transition-all after:duration-300 hover:after:w-full"
              >
                Home
              </Link>

              <Link
                to="/about"
                className="font-semibold text-gray-800 hover:text-blue-600 transition-colors relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-blue-600 after:transition-all after:duration-300 hover:after:w-full"
              >
                About
              </Link>

              <Link
                to="/services"
                className="font-semibold text-gray-800 hover:text-blue-600 transition-colors relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-blue-600 after:transition-all after:duration-300 hover:after:w-full"
              >
                Services
              </Link>

              <Link
                to="/gallery"
                className="font-semibold text-gray-800 hover:text-blue-600 transition-colors relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-blue-600 after:transition-all after:duration-300 hover:after:w-full"
              >
                Gallery
              </Link>

              <Link
                to="/blogs"
                className="font-semibold text-gray-800 hover:text-blue-600 transition-colors relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-blue-600 after:transition-all after:duration-300 hover:after:w-full"
              >
                Blogs
              </Link>

              <Link
                to="/contact"
                className="font-semibold text-gray-800 hover:text-blue-600 transition-colors relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-blue-600 after:transition-all after:duration-300 hover:after:w-full"
              >
                Contact
              </Link>
            </nav>

            {/* Contact */}
            <div className="hidden lg:flex items-center gap-3">
              <div className="h-10 w-10 rounded-full bg-gradient-to-r from-blue-100 to-indigo-100 flex items-center justify-center shadow-sm">
                <Phone size={18} className="text-blue-600" />
              </div>
              <div>
                <p className="text-xs text-gray-500 font-medium">Call Now</p>
                <a
                  href="tel:+61420499661"
                  className="font-bold text-gray-900 hover:text-blue-600 transition-colors text-lg"
                >
                  +61 420 499 661
                </a>
              </div>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden h-10 w-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors relative z-60"
            >
              {mobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden fixed inset-x-0 top-0 bg-white shadow-2xl z-40 transition-all duration-500 ease-in-out ${
          mobileMenuOpen
            ? "translate-y-0 opacity-100"
            : "-translate-y-full opacity-0 pointer-events-none"
        }`}
        style={{ height: "100vh", marginTop: "86px" }}
      >
        <div className="overflow-y-auto h-full px-4 py-6">
          <div className="space-y-1">
            <Link
              to="/"
              className="block py-4 px-4 text-lg font-semibold text-gray-800 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Home
            </Link>

            <Link
              to="/about"
              className="block py-4 px-4 text-lg font-semibold text-gray-800 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors border-t"
              onClick={() => setMobileMenuOpen(false)}
            >
              About
            </Link>

            <Link
              to="/services"
              className="block py-4 px-4 text-lg font-semibold text-gray-800 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors border-t"
              onClick={() => setMobileMenuOpen(false)}
            >
              Services
            </Link>

            <Link
              to="/gallery"
              className="block py-4 px-4 text-lg font-semibold text-gray-800 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors border-t"
              onClick={() => setMobileMenuOpen(false)}
            >
              Gallery
            </Link>

            <button
              onClick={(e) => {
                setMobileMenuOpen(false);
                scrollToFAQ(e);
              }}
              className="block w-full text-left py-4 px-4 text-lg font-semibold text-gray-800 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors border-t"
            >
              FAQ
            </button>

            <Link
              to="/contact"
              className="block py-4 px-4 text-lg font-semibold text-gray-800 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors border-t"
              onClick={() => setMobileMenuOpen(false)}
            >
              Contact
            </Link>
          </div>

          {/* Mobile Contact */}
          <div className="mt-8 pt-6 border-t">
            <div className="flex items-center gap-3 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl">
              <div className="h-12 w-12 rounded-full bg-gradient-to-r from-blue-600 to-indigo-700 flex items-center justify-center">
                <Phone size={20} className="text-white" />
              </div>
              <div>
                <p className="text-sm text-gray-600 font-medium">Emergency Line</p>
                <a
                  href="tel:+10001234567"
                  className="text-xl font-bold text-gray-900 hover:text-blue-600 transition-colors"
                >
                  +61 420 499 661
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;